import React from 'react';

// Layout simplifié — Header/Footer/ProgressBar gérés par SharedLayout dans App.js
const QuoteFormLayout = ({ children }) => {
  return (
    <div className="quote-form-wrapper">
      {children}
    </div>
  );
};

export default QuoteFormLayout;